var degreesToRadians = function (degrees) { return (degrees * Math.PI) / 180; };

export { degreesToRadians };
